'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ca_ES = require('../../date-picker/locale/ca_ES');

var _ca_ES2 = _interopRequireDefault(_ca_ES);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

exports["default"] = _ca_ES2["default"];
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./components/calendar/locale/ca_ES.tsx
 ** module id = 772
 ** module chunks = 1
 **/